var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"vux-table",class:{'vux-table-bordered': _vm.fullBordered, 'vux-table-no-cell-bordered': !_vm.cellBordered, 'vux-table-no-content-bordered': !_vm.contentBordered}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }